import { MutationTree } from 'vuex';

import { snakeToCamel } from '@/utils';

import { PatientStateI, MedicalConsultationsDataI, PatientUserI } from './state';
import { ResultsI } from '../state';
import { UserI } from '../users/state';

const mutations: MutationTree<PatientStateI> = {
  setPatient(state: PatientStateI, payload: PatientUserI) {
    state.patientUser = payload;
  },
  setPatientsFinded(state: PatientStateI, payload: ResultsI) {
    state.patientsFinded = payload;
  },
  setPatientUser(state: PatientStateI, payload: PatientUserI) {
    state.patientUser = payload;
  },
  setMedicalConsultations(state: PatientStateI, payload: MedicalConsultationsDataI) {
    // convert object to array
    const mc = Object.keys(payload.medicalConsultations)
      .map((key) => payload.medicalConsultations[key as any]);
    const medicalConsultations = mc
      .map((consultation) => {
        const c = snakeToCamel(consultation);
        const doctor = snakeToCamel(consultation.doctor);
        const userDoctor = snakeToCamel(consultation.doctor.user);

        doctor.user = userDoctor;
        c.doctor = doctor;

        return c;
      });

    const patient = snakeToCamel(payload.patient);
    // const userPatient = snakeToCamel(payload.patient.user);

    // patient.user = userPatient;

    state.medicalConsultations.medicalConsultations = medicalConsultations;
    state.medicalConsultations.patient = patient;
  },
};

export default mutations;
